<template>
	<div class="module-page">
		<Card class="upload-card">
			<Form ref="searchForm" :model="searchForm" inline style="text-align: left;margin-top: 1%; width: 100%;">
				<FormItem :label="$tt('充电站:')" :label-width="70" prop="StationId">
					<Select filterable :placeholder="$tt('站点列表')" style="width: 150px;" v-model="searchForm.StationId">
						<Option :value="0">{{$tt('全部')}}</Option>
						<Option v-for="item in StationList" :key="item.StationId" :value="item.StationId">
							{{item.StationName}}
						</Option>
					</Select>
				</FormItem>
				<FormItem prop="EquipmentNo">
					<Input style="width: 180px;" type="text" v-model="searchForm.EquipmentNo" :placeholder="$tt('设备编号')">
						<span slot="prepend">{{$tt('设备编号')}}</span>
					</Input>
				</FormItem>
				<FormItem prop="EquipmentSerialNo">
					<Input style="width: 180px;" type="text" v-model="searchForm.EquipmentSerialNo" :placeholder="$tt('设备序列号')">
						<span slot="prepend">{{$tt('设备序列号:')}}</span>
					</Input>
				</FormItem>
				<FormItem>
					<Button type="primary" @click="handleSubmitList">{{$tt('查询')}}</Button>
				</FormItem>
			</Form>
		</Card>
		<Card :title="$tt('模块信息列表')" style="margin-top: 8px;">
			<Table :columns="tableColumns" :data="tableData" stripe border row-key="Id" :height="tableHeight">
				<MyPage slot="footer" ref="sonPageList" :param="searchForm" :url="getPowerModuleInfoUrl" @listData='getModuleList'>
				</MyPage>
			</Table>
		</Card>
	</div>
</template>
<script>
import expandRow from './Template/ModuleExpand.vue';
import { mapState } from 'vuex'
import webapi from '../../../webapi';
export default {
	name: 'ModuleInfo',
	computed: {
		...mapState({
			StationList: 'Stations',
		})
	},
	mounted() {
		//this.SelectParam = this.$refs.MyTerm.formInline
		this.$nextTick(() => {
			// this.handleSubmitFile();
			this.handleSubmitList();
		})
	},
	created() {
		const _this = this;
		// _this.tableHeight = window.innerHeight - 220;
		_this.getTableHeight();
		window.addEventListener('resize', this.getTableHeight)
	},
	destroyed() {
		window.removeEventListener("resize", this.getTableHeight);
	},

	data() {
		return {
			getPowerModuleInfoUrl: webapi.base_api_url + '/Operations/GetPowerModuleInfo',
			searchForm: {
				StationId: 0,
				EquipmentNo: '',
				EquipmentSerialNo: '',
			},
			tableHeight: "650",
			tableColumns: [
				{
					type: 'expand',
					width: 50,
					render: (h, params) => {
						return h(expandRow, {
							props: {
								row: params.row
							}
						})
					}
				},
				{
					title: 'ID',
					key: 'Id',
					width: 80
				},
				{
					title: this.$tt('设备序列号'),
					key: 'EquipSerialNo',
					minWidth: 120
				},
				{
					title: this.$tt('模块地址'),
					key: 'ModuleAddr',
					minWidth: 100
				},
				{
					title: this.$tt('模块状态'),
					key: 'ModuleStatus',
					minWidth: 100,
					render: (h, params) => {
						const val = params.row.ModuleStatus;
						return h('Tag', {
							props: {
								color: val === 1 ? 'success' : 'default'
							}
						}, val === 1 ? '开机' : '关机');
					}
				},
				{
					title: this.$tt('输出电压(V)'),
					key: 'OutputVoltage',
					minWidth: 120
				},
				{
					title: this.$tt('输出电流(A)'),
					key: 'OutputCurrent',
					minWidth: 120
				},
				{
					title: this.$tt('模块温度(℃)'),
					key: 'ModuleTemp',
					minWidth: 120
				},
				{
					title: this.$tt('上报时间'),
					key: 'ReportTime',
					minWidth: 170
				},
			],
			tableData: []
		};
	},
	methods: {
		getModuleList(data) {
			this.tableData = data.Data.List;
		},
		handleSubmitList() {
			this.$refs.sonPageList.getList();
		},
		getTableHeight: function() {
			this.tableHeight = window.innerHeight - 265;
			if (window.innerWidth < 872) {
				this.tableHeight -= 56;
			}
			// if (window.innerWidth < 1017) {
			// 	this.tableHeight -= 53;
			// }
			if (window.innerWidth < 610) {
				this.tableHeight -= 56;
			}
		},
	}
};
</script>
<style scoped>
	.desc-container {
		padding: 16px 24px;
		background: #fafafa;
	}
	.desc-item {
		margin: 8px 0;
		font-size: 14px;
	}
	.label {
		color: #666;
		display: inline-block;
		width: 140px;
	}
</style>
